import { Box, Typography, useMediaQuery } from "@mui/material"
import { theme } from "../Theme";

export const CoachingIntro: React.FC = () => {
    const sm = useMediaQuery(theme.breakpoints.up('sm'));

    return  (  
    <>
        <Box className="descriptionDiv" style={{minHeight: '400px'}}>
        <Typography variant={sm?"h5":'h6'} color="primary" component="h2"><strong>Dein Mehrwert</strong></Typography>
        <Typography variant="body1" textAlign="left" component="div" paddingTop="50px">
        <p>{'Du lernst nachhaltig mit Stress umzugehen, Du lernst Deine Emotionen kennen, Du schaffst mit meiner Hilfe den perfekten Start in deine Hochzeitsplanung.'}</p>
        <p>{'Wir gehen emotionale und schwierige Themen an, die Dich an einer entspannten Planung hindern.'}</p>
        <p>{'Ich coache Dich ganzheitlich und intensiv über 6 Monate oder in einer kürzeren Variante über 6 Wochen mit Schwerpunkt auf deinem Wohlbefinden oder mit Schwerpunkt auf guter Struktur & Organisation.'}</p>
        </Typography>
        </Box>
    </>
    )
}